// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__g8xxG","tagAsButton":"Tag_tagAsButton__MHqIO","error":"Tag_error__0kfOp"};